import { Button } from 'components/Button/Button'
import { useTranslation } from 'react-i18next'

export interface WarningContinueProps {
  onClose: () => void,
  setWarningDisplayAcceptedAltFormat: (arg: boolean) => void
}

export const WarningContinue: React.FC<WarningContinueProps> = ({ onClose, setWarningDisplayAcceptedAltFormat }) => {
  const { t } = useTranslation(['common'])

  return (
      <div className='ds-c-dialog__actions'>
        <div className='ds-l-form-row'>
          <div className='ds-l-col--12 ds-l-sm-col--auto my-u-my--2'>
            <Button className='ds-c-button ds-c-button--solid my-u-py--6 my-u-width--full' onClick={() => setWarningDisplayAcceptedAltFormat(true)}>
              {t('continue')}
            </Button>
          </div>
          <div className='ds-l-col--12 ds-l-sm-col--auto my-u-my--2'>
            <Button className='ds-c-button my-u-py--6 my-u-width--full' onClick={onClose}>
              {t('cancel')}
            </Button>
          </div>
        </div>
      </div>
  )
}
